import moment from 'moment'
import { DateRangePicker } from '@src/components'
import { REGISTER_COLUMNS } from '@src/constants'
import { RegisterColumn } from './RegisterColumn'
import { requestArgsDateRange } from './columnsReqArgs'

export class FirstDiagBeginOn extends RegisterColumn {
  static type = REGISTER_COLUMNS.FIRST_DIAG_BEGIN_ON

  constructor (store, settings) {
    const column = {
      header: {
        title: 'Дата установления диагноза впервые в жизни',
        component: DateRangePicker,
        defaultValue: [null, null],
        props: {
          allowClear: true,
          allDay: true,
          allowEmpty: [true, true],
          disabledDate: currentDate => currentDate && currentDate.isAfter(moment()),
        },
      },
      width: 250,
      nullSearch: true,
      dataIndex: 'first_diag_begin_on',
      dataRender: first_diag_begin_on => first_diag_begin_on ? moment(first_diag_begin_on).format('DD.MM.YYYY') : '-',
      sort: true,
    }

    super(column, settings)
  }

  _requestArgs = reqArgs => requestArgsDateRange(this.type, reqArgs)
}
